import i18next from 'i18next'

export default function localizeCurrency({
  amountInCents,
  currency,
}: {
  amountInCents: number | undefined
  currency: string | undefined
}): string | undefined {
  if (amountInCents == null || !currency) return

  const amount = Math.floor(amountInCents) / 100

  return new Intl.NumberFormat(i18next.language.split('-')[0], {
    currency: currency,
    currencyDisplay: 'narrowSymbol',
    style: 'currency',
  }).format(amount)
}
